import { computed } from '@ember/object';
import CatalogObject from '@square/dashboard-items-data/models/squareup/inventory/v3/catalog-object';
import { CATALOG_SERVICE_ATTRIBUTE_DEFINITIONS } from '@square/dashboard-data/models/catalog/catalog-service-constants';
export default CatalogObject.extend({
  name: computed('attribute.[]', function () {
    return this.getAttrStringValueByDefToken(CATALOG_SERVICE_ATTRIBUTE_DEFINITIONS.name.token);
  }),
  sku: computed('attribute.[]', function () {
    return this.getAttrStringValueByDefToken(CATALOG_SERVICE_ATTRIBUTE_DEFINITIONS.sku.token);
  }),
  gtin: computed('attribute.[]', function () {
    return this.getAttrStringValueByDefToken(CATALOG_SERVICE_ATTRIBUTE_DEFINITIONS.gtin.token);
  })
});